import { t } from 'ttag';

import { REG_FORM_WIDGET_TYPE } from './regForm';

// Matches the API's contentEntityType values.
export const WIDGET_ENTITY_TYPE = {
  PEOPLE: 'people',
  SESSIONS: 'sessions',
  COMPANIES: 'companies',
};

export const getWidgetTypeLabel = type =>
  ({
    [WIDGET_ENTITY_TYPE.PEOPLE]: t`People`,
    [WIDGET_ENTITY_TYPE.SESSIONS]: t`Sessions`,
    [WIDGET_ENTITY_TYPE.COMPANIES]: t`Companies`,
    [REG_FORM_WIDGET_TYPE]: t`Registration`,
  })[type];

const WIDGET_LAYOUT = {
  LIST: 'list',
  GRID: 'grid',
  CAROUSEL: 'carousel',
};

export const getLayoutOptions = () => [
  { label: t`List`, value: WIDGET_LAYOUT.LIST },
  { label: t`Grid`, value: WIDGET_LAYOUT.GRID },
  { label: t`Carousel`, value: WIDGET_LAYOUT.CAROUSEL },
];

// styleConfig is FE-owned; the backend stores it without reading it.
export const DEFAULT_STYLE_CONFIG = {
  layout: WIDGET_LAYOUT.LIST,
  colors: {
    accent: '#1677FF',
    text: '#222222',
    widgetBackground: '#FAFAFA',
    cardBackground: '#FFFFFF',
  },
  image: { size: 200, cornerRadius: 0 },
  concurrentSessions: false,
};
